<!-- 新增商品第二步 -->
<template>
  <div>
    <!-- <div class="step-container">
      <el-steps :active="2">
        <el-step title="选择分类"></el-step>
        <el-step title="编辑商品基本信息"></el-step>
        <el-step title="编辑商品详细信息"></el-step>
        <el-step title="提交审核"></el-step>
        <el-step title="发布完成"></el-step>
      </el-steps>
    </div> -->

    <floor-1></floor-1>
  </div>
</template>

<script>
import floor1 from "../../../components/product/productManage/productTeamInfo.vue";
export default {
  data() {
    return {
      active: 1,
      input1: "",
      fristCategry: ["动力轴", "动力轴", "动力轴", "动力轴", "动力轴"],
    };
  },

  components: {
    floor1,
  },

  computed: {},

  created() {},
  methods: {},
};
</script>
<style lang='scss' scoped>
.step-container {
  margin: 20px 52px;
}
.sort-content {
  padding: 0 30px;
  .sort-search {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
  }
}
.btn-box {
  display: flex;
  margin-top: 30px;
  justify-content: center;
}
.category {
  display: flex;
  justify-content: space-between;
  .item-box {
    padding: 10px;
    width: 23%;
    border: 1px solid #ddd;
    .item-input {
      margin-bottom: 10px;
    }
    .item-name {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>